<template>
  <div class="page-upload-video xc-modal xc-modal-page">
    <div class="xc-modal-wrap">
      <div class="xc-modal-content">
        <div class="xc-modal-header">
          <div class="xc-modal-title">选择视频</div>
          <div
            class="xc-modal-close"
            @click="layerClose"
          ></div>
        </div>
        <div class="xc-modal-body">
          <div v-if="channel == '0'">
            <form class="form">
              <xc-form-item
                label="播放时长(秒)"
                class="xc-form-item-fixed"
                required
              >
                <span v-if="data.files && data.files.length">
                  <input
                    type="text"
                    disabled="disabled"
                    class="xc-input xc-input-disabled"
                    :value="((data.files[0].duration||0) / 1000)"
                  >
                </span>
                <span v-else>
                  <input
                    type="text"
                    disabled="disabled"
                    value="0"
                    class="xc-input xc-input-disabled"
                  >
                </span>
              </xc-form-item>
              <xc-form-item
                label="视频"
                style="align-items: inherit;"
                required
              >
                <xc-upload
                  :fileList.sync="data.files"
                  type="0"
                  accept="video/*"
                  :url="uploadUrl"
                  :multiple="true"
                  :beforeUpload="beforeUpload"
                />
                <div class="upload-tip">
                  <span>上传限制：</span>
                  <span>最大 {{sysConfig.upload_max_video_size.value}}MB</span>
                  <span>，支持格式：{{sysConfig.pass_video_suffix.value}}</span>
                </div>
              </xc-form-item>
            </form>
          </div>
          <div v-if="channel == '1'">
            <form
              class="form"
              style="width: 279px;"
            >
              <xc-form-item
                label="选择分组"
                required=""
                :error="errors.first('groupId')"
              >
                <select
                  name="groupId"
                  class="xc-select"
                  v-validate="'required'"
                  data-vv-as="分组"
                  v-model="fileGroupId"
                >
                  <option value="">请选择</option>
                  <template v-if="fileGroups.length">
                    <option
                      v-for="(item,index) in fileGroups"
                      :key="index"
                      :value="item.fileGroupId"
                    >{{item.fileGroupName}}</option>
                  </template>
                </select>
              </xc-form-item>
              <xc-form-item
                label="视频"
                style="align-items: inherit;"
                required
              >
                <xc-upload
                  :fileList.sync="data.files"
                  type="0"
                  accept="video/*"
                  :url="uploadUrl"
                  :multiple="true"
                  :beforeUpload="beforeUpload"
                />
                <div class="upload-tip" v-if="sysConfigLoaded && sysConfig.upload_max_video_size">
                  <span>上传限制：</span>
                  <span>最大 {{sysConfig.upload_max_video_size.value}}MB</span>
                  <span>，支持格式：{{sysConfig.pass_video_suffix.value}}</span>
                </div>
              </xc-form-item>
            </form>
          </div>
        </div>
        <div class="xc-modal-footer xc-flex-center">
          <div class="xc-btn-group">
            <div
              class="xc-btn xc-btn-default"
              @click="layerClose"
            >取消</div>
            <div
              class="xc-btn xc-btn-primary"
              @click.prevent="submit"
            >确定</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@/libs/vee-validate'
// import myLayerImport from '@/libs/myLayer'
import material from "@/api/material"
// myLayerImport();

import sysconfigApi from "@/api/sysconfig"
import { showApiError } from '@/utils/api-message'

export default {
  name: 'materialUploadImage',
  data() {
    return {
      // 来源渠道 0、节目编辑器（图片上传） 1、素材库（图片上传）
      channel: this.$route.query.channel || 0,
      fileGroups: [],  //素材分组
      fileGroupId: this.$route.query.fileGroupId || '',  //当前分组ID
      data: {
        duration: 0,
        files: [],
      },
      uploadUrl: '/file/uploadVideo',
      sysConfigLoaded: false,
      sysConfig: {
        upload_max_video_size: { value: '' },
        pass_video_suffix: { value: '' }
      }
    }
  },

  created() {
    var _this = this;
    // 获取channel
    this.channel = this.$route.query.channel;
    if (this.channel == 1) {
      //    获取素材分组
      material.getFileGroup().then(function (success) {
        _this.fileGroups = success.data;
      }).catch(function (error) {
        console.log(error)
      })
    }

    // 获取系统设置
    sysconfigApi.getConfig().then((ret) => {
      const sysConfig = {};
      ret.data.map(item => {
        sysConfig[item.type] = item;
      })

      this.sysConfig = sysConfig;
      // 将页面/校验最大值统一提升到 1GB（1024MB）
      if (this.sysConfig.upload_max_video_size && this.sysConfig.upload_max_video_size.value !== undefined) {
        const configuredMb = Number(this.sysConfig.upload_max_video_size.value);
        const maxMb = Number.isFinite(configuredMb) ? Math.max(configuredMb, 1024) : 1024;
        this.sysConfig.upload_max_video_size.value = maxMb;
      }
      this.sysConfigLoaded = true;
    }).catch(() => {
      this.$message.error('上传配置获取失败，请稍后重试');
      this.sysConfigLoaded = true;
    })
  },

  methods: {
    layerClose() {
      var index = parent.layer.getFrameIndex(window.name);
      parent.layer.close(index);
    },

    submit() {
      this.$validator.validateAll().then(validate => {
        if (validate) {
          if (!this.data.files || this.data.files.length == 0) {
            return this.$message.error('请上传视频');
          }

          const file = this.data.files[0];
          if (file.status && file.status !== 'success') {
            return this.$message.warning('视频正在上传中，请稍后再提交');
          }
          if (!file.url) {
            return this.$message.error('请上传视频');
          }
          if (!file.md5) {
            return this.$message.error('MD5 计算失败，请重新上传');
          }

          const returnData = this.data.files.map(file => {
            return {
              duration: Number(file.duration),
              fileSuffix: file.fileSuffix,
              url: file.url,
              fileName: file.fileName,
              md5: file.md5,
              size: file.size,
              fileType: 'video',
              fileImageUrl: file.fileImageUrl,
              fileGroupId: this.fileGroupId,
            }
          })

          const confirmData = this.data.files.map(file => {
            return {
              ...file,
              fileType: 'video',
              groupId: this.fileGroupId,
            }
          })

          // 将素材入库
          material.uploadSure({
            files: JSON.stringify(confirmData),
          }).then(() => {
            parent.window.videoUploadSubmit(returnData);
            this.layerClose();
          }).catch((err) => {
            showApiError(this, err, '素材入库失败');
          })
        } else {
          let error = this.errors.items[0].msg;
          this.$message.error(error)
        }
      })
    },


    beforeUpload(file) {

      if (!this.sysConfig.upload_max_video_size) {
        this.$message.error('上传配置获取失败，请稍后重试');
        return false;
      }

      // 将前端最大限制从 60MB 调整为 1GB（即使服务端配置返回更小，也允许上传）
      const configuredMb = Number(this.sysConfig.upload_max_video_size.value);
      const maxMb = Number.isFinite(configuredMb) ? Math.max(configuredMb, 1024) : 1024;
      const maxSize = maxMb * 1024 * 1024;
      const passSuffix = this.sysConfig.pass_video_suffix.value.split(',');

      if (file.size > maxSize) {
        this.$message.error('视频大小不能超过' + maxMb + 'MB');
        return false;
      }

      const suffixAry = file.name.split('.');
      if (suffixAry.length == 0) {
        this.$message.error('文件格式不正确，请上传' + passSuffix.join(',') + '格式文件');
        return false;
      }

      // 判断是否允许的格式
      const allowType = passSuffix.some(item => {
        return suffixAry[suffixAry.length - 1].toLowerCase() == item.toLowerCase();
      });

      // 不允许的文件格式
      if (!allowType) {
        this.$message.error('文件格式不正确，请上传' + passSuffix.join(',') + '格式文件');
        return false;
      }
    }
  }
}
</script>

<style lang="scss">
.page-upload-video {
  .xc-form-item-label {
    min-width: 90px;
  }
  .upload-tip {
    margin-top: 8px;
    font-size: 12px;
    color: #999;
    span {
      &:nth-child(2) {
        color: #f56c6c;
      }
    }
  }
}
</style>